import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { DashboardNavigationLink, LeftNavigationBar } from 'common/Navigation';
import { wrk107TasksPageDisplayScreeningsSidebarItem } from 'src/common/utils/FeatureFlags/flags';

export const TasksV3Sidebar = ({ router, shouldShowScreeningTasksNav }) => (
  (
    <LeftNavigationBar className="space-y-2">
      <>
        <DashboardNavigationLink
          key="all"
          to="/tasksv3/all"
          label="All Tasks"
          className="text-sm"
          data-testid="all-tasks-v3-nav"
          isActive={router && router.isActive({ pathname: '/tasksv3/all' })}
        />
        {shouldShowScreeningTasksNav && (
          <>
            <DashboardNavigationLink
              key="inbound-screening"
              to="/tasksv3/inbound-screenings"
              label="Inbound Screening Tasks"
              className="text-sm"
              data-testid="inbound-screening-tasks-v3-nav"
              isActive={router && router.isActive({ pathname: '/tasksv3/inbound-screenings' })}
            />
            <DashboardNavigationLink
              key="user-created"
              to="/tasksv3/user-created"
              label="User-Created Tasks"
              className="text-sm"
              data-testid="user-created-tasks-v3-nav"
              isActive={router && router.isActive({ pathname: '/tasksv3/user-created' })}
            />
          </>
        )}
      </>
    </LeftNavigationBar>
  )
);

TasksV3Sidebar.propTypes = {
  router: PropTypes.shape({
    isActive: PropTypes.func,
  }),
  shouldShowScreeningTasksNav: PropTypes.bool,
};

TasksV3Sidebar.defaultProps = {
  router: null,
  shouldShowScreeningTasksNav: false,
};

const mapStateToProps = (state) => ({
  shouldShowScreeningTasksNav: wrk107TasksPageDisplayScreeningsSidebarItem(state),
});

export default connect(mapStateToProps)(withRouter(TasksV3Sidebar));
